import React from 'react';
import './Footer.css';
import {useTranslation} from "react-i18next";
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className={'foot-wrap'}>
        <div className="footer-section">
          <h4>{t('productAbout')}</h4>
          <ul>
            <li><a href="/hybrid/moduleList.html">{t('productInt')}</a></li>
            <li><a href="/hybrid/downloadCenter.html">{t('productDown')}</a></li>
            <li><a href="/hybrid/tutorialList.html">{t('tutorialIntro')}</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{t('companyAbout')}</h4>
          <ul>
            <li><Link to="about">{t('aboutUs')}</Link></li>
            <li><Link to="privacy">{t('privacy')}</Link></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
